import { callToMain } from '../eventLoop';
import { AnimateParams } from './types';

export const timingFunction = {
  linear: (fraction: number) => fraction,
  easeOut: (fraction: number) => 1 - Math.pow(1 - fraction, 3),
};

/**
 * Запускает requestAnimationFrame анимацию
 * @returns коллбек для досрочной остановки запущенной анимации
 */
export function animate(params: AnimateParams): VoidFunction {
  const { duration, timing = timingFunction.linear, draw, onAnimationEnd } = params;

  let start: number | undefined;

  let requestAnimationId = requestAnimationFrame(function animate(time) {
    if (!start) {
      start = time;
    }

    let timeFraction = (time - start) / duration;

    if (timeFraction > 1) {
      timeFraction = 1;
    }

    draw(timing(timeFraction));

    if (timeFraction < 1) {
      requestAnimationId = requestAnimationFrame(animate);
    } else if (onAnimationEnd) {
      requestAnimationId = requestAnimationFrame(() => callToMain(onAnimationEnd));
    }
  });

  return () => cancelAnimationFrame(requestAnimationId);
}
